import React from 'react'
import styled from '@emotion/styled'

import {Text} from '@vio/atlas/Text'

const Title = styled(Text)`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`

interface Props {
  name?: string
}

export const OtaOfferRoomName = ({name}: Props) => {
  if (!name) return null
  return (
    <Title
      variant="titleM"
      colorPath="content.neutral.primary"
      data-id="OtaOfferRoomName"
    >
      {name}
    </Title>
  )
}
